<script setup>
import {computed, nextTick, onMounted, ref, watch} from 'vue'
import { trans } from 'laravel-vue-i18n'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import Button from "primevue/button";
import EmbedMap from "../../../../widget/components/ui-components/EmbedMap.vue";

const props = defineProps({
    type: String,
    name: String,
    address: Object,
    service: String,
    coords: Array
})

const emit = defineEmits(['delete', 'edit']);

const serviceName = computed(() => {
    if (props.type === 'in_person') {

        const a = props.address?.address;
        let address = [];
        if (a?.road)
            address.push(a?.road + (a?.house_number ? ' ' + a?.house_number : ''))

        if (a?.town)
            address.push(a?.town)

        if (a?.country)
            address.push(a?.country)
        return address.join(', ');
    }

    switch (props.service) {
        case 'ms_teams':
            return 'Microsoft Teams';
        case 'phone_call':
            return trans('reservations.location_service_phone');
        case 'google_meet':
            return 'Google Meet';
        case 'whatsapp':
            return 'WhatsApp';
        default:
            const a = props.address?.address;
            let address = [];
            if (a?.road)
                address.push(a?.road + (a?.house_number ? ' ' + a?.house_number : ''))

            if (a?.town)
                address.push(a?.town)

            if (a?.country)
                address.push(a?.country)
            return address.join(', ');
    }
})

const serviceIcon = computed(() => {
    if (props.type === 'in_person') return 'pi pi-map-marker';
    switch (props.service) {
        case 'ms_teams':
            return 'bi bi-microsoft-teams';
        case 'google_meet':
            return 'pi pi-google';
        case 'whatsapp':
            return 'bi bi-whatsapp';
        case 'phone_call':
            return 'pi pi-phone';
        default:
            return 'pi pi-map-marker';
    }
})

</script>

<template>
  <div class="shadow w-full border dark:border-neutral-700 overflow-hidden rounded">
    <div v-if="type === 'in_person'" class="border-t dark:border-neutral-700">
        <EmbedMap :coordinates="{ lat: props.coords[0], lng: props.coords[1] }" :height="150" color="blue"/>
    </div>

    <div class="p-4 flex gap-2 items-center">
      <i :class="`${serviceIcon} text-roori-blue mx-2`"></i>
      <div class="grow">
        <p class="font-semibold">{{ name }}</p>
        <p class="text-xs">{{ serviceName }}</p>
      </div>
      <Button
        icon="pi pi-pencil"
        severity="secondary"
        @click="emit('edit')"
        text
      />
      <Button
        icon="pi pi-trash"
        severity="danger"
        @click="emit('delete', $event)"
        text
      />
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
